module.exports = __webpack_public_path__ + "static/media/preloader_button.2388e155.gif";